export default __webpack_public_path__ + "static/media/electric-generator.cb0a2149.svg";